
import Vue from 'vue'
import { getSortedProductsList } from '@/categories/helper'
import ProductSectionProducts from '@/categories/components/ProductSectionProducts.vue'
import { ProductType } from '@/types'
import { SYSTEM_ERROR } from '@/common/constants'
import { SORT_ORDER, SORT_LABEL } from '@/categories/const'
import { hashEmail } from '@/common/utils/common'
import { getJsonData } from '@/common/utils/dom'

export default Vue.extend({
  components: {
    ProductSectionProducts
  },
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    sortOrder: {
      type: String,
      required: true
    }
  },
  data(): {
    productList: ProductType[]
  } {
    return {
      productList: []
    }
  },
  computed: {
    title(): string {
      return this.isSortByDeliveryDate ? SORT_LABEL.DELIVERY_DATE : SORT_LABEL.BUDGET
    },
    suffix(): string {
      return this.isSortByDeliveryDate ? SORT_LABEL.QUICK_DELIVERY : SORT_LABEL.LOW_UNIT_PRICE
    },
    isSortByDeliveryDate(): boolean {
      return this.sortOrder === SORT_ORDER.SORT_BY_DELIVERY_DATE
    },
    isShowProductList(): boolean {
      return this.productList.length >= 10
    }
  },
  async created() {
    await this.fetchData()
  },
  methods: {
    hashEmail,
    getUserDevice() {
      const ua = navigator.userAgent
      if (/iPhone|iPad|iPod|Android.+Mobile|Windows Phone/.test(ua))
        return 'm' // Mobile
      else if (/iPad|Android/.test(ua))
        return 't' // Tablet
      else
        return 'd' // Desktop
    },
    async fetchData() {
      const { data } = await getSortedProductsList(this.categoryId, this.sortOrder).catch(()=> alert(SYSTEM_ERROR.UNKNOWN))
      if (data) {
        this.productList = data.productsForCategoryPage.items
        if (this.isSortByDeliveryDate) {
          const currentUser = getJsonData('#currentUser') || null
          const hashedEmail = currentUser ? await hashEmail(currentUser.email) : ''

          const firstThreeProductIds = this.productList.slice(0, 3).map(product => product.id)

          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            'PageType': 'Listingpage',
            'HashedEmail': hashedEmail,
            'ProductIDList': firstThreeProductIds
          })

          window.criteo_q = window.criteo_q || []
          window.criteo_q.push(
            { event: 'setAccount', account: 67948  },
            { event: 'setSiteType', type: this.getUserDevice() },
            { event: 'viewList', item: firstThreeProductIds }
          )

        }
      }
    }
  }
})
